import { Button } from 'rsuite';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  height: calc(100vh - 60px);
  background-color: ${({ theme }) => theme.colors.background};
`;

/* ---- Page Header ---- */

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const HeaderBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 34px;
  padding: 0 16px;
  border: 1px solid ${({ theme }) => theme.colors.text}12;
  border-radius: 999px;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;

  &:hover {
    border-color: ${({ theme }) => theme.colors.info}40;
    color: ${({ theme }) => theme.colors.info};
  }

  &:active {
    transform: scale(0.97);
  }
`;

export const HeaderIconBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 1px solid ${({ theme }) => theme.colors.text}12;
  border-radius: 999px;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  color: ${({ theme, $active }) => $active
    ? theme.colors.success
    : theme.colors.textSecondary};
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.info}40;
    color: ${({ theme, $active }) => $active ? theme.colors.success : theme.colors.info};
  }

  &:active {
    transform: scale(0.95);
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

/* ---- Content ---- */

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  flex-grow: 1;
  animation: ${fadeIn} 0.3s ease-out;

  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.text}18;
    border-radius: 4px;

    &:hover {
      background-color: ${({ theme }) => theme.colors.text}35;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  min-width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow-y: hidden;
  flex: 1;
  gap: 10px;
`;

export const LoadingContainer = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

export const LoadingText = styled.span`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 13px;
  font-weight: 400;
  animation: ${pulse} 2s ease-in-out infinite;
`;

/* ---- Column ---- */

export const ColumnContainer = styled.div`
  flex-grow: 1;
  width: 24vw;
  min-width: 300px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colors.text}08;
  box-shadow: 0 10px 28px -18px rgba(0, 0, 0, 0.35);
  overflow: hidden;
`;

export const ButtonConclude = styled(Button)`
  display: flex;
  padding: 2px 8px;
  margin-left: auto;
  font-size: 10px;
  border-radius: 20px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
  background-color: rgba(255, 255, 255, 0.15);
  border: none;
  transition: all 0.2s ease;
  letter-spacing: 0.2px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.3);
    color: #fff;
  }
`;
